import axios from 'axios';
import { configEnv } from '@/shared/config-env';
import { ownerEmail } from '@/shared/composition';
import { v4 as uuidv4 } from 'uuid';
import { emojiEliminateRequestInterceptor } from '@/shared/lib/emojiEliminate/interceptor';

axios.defaults.baseURL = configEnv.VUE_APP_LOYALTY_API_URL;

const _axios = axios.create({});

_axios.interceptors.request.use(
  config => {
    if (config.headers) {
      config.headers['X-Request-ID'] = uuidv4();
      config.headers['x-source-lp'] = ownerEmail.value ? 'personalAreaPartnerLP' : 'personalAreaClientLP';
    }

    emojiEliminateRequestInterceptor(config);
    return config;
  },
);

export default _axios;
